import React from 'react';

import {
	type HubBreadcrumbDefinition,
	useAreHubBreadcrumbsEnabled,
	useHubBreadcrumbs,
} from '../hub-breadcrumbs';

export type DynamicHubBreadcrumbItem = HubBreadcrumbDefinition;
export { useAreHubBreadcrumbsEnabled };

const DynamicHubBreadcrumbsRegistrar = ({
	ancestorItems,
	currentItem,
}: {
	ancestorItems?: readonly DynamicHubBreadcrumbItem[];
	currentItem: DynamicHubBreadcrumbItem;
}): null => {
	useHubBreadcrumbs({ ancestorItems, currentItem });

	return null;
};

export const DynamicHubBreadcrumbs = ({
	ancestorItems,
	currentItem,
}: {
	ancestorItems?: readonly DynamicHubBreadcrumbItem[];
	currentItem: DynamicHubBreadcrumbItem;
}): JSX.Element | null => {
	const isBreadcrumbsEnabled = useAreHubBreadcrumbsEnabled();

	if (!isBreadcrumbsEnabled) {
		return null;
	}

	return <DynamicHubBreadcrumbsRegistrar ancestorItems={ancestorItems} currentItem={currentItem} />;
};
